module.exports = __webpack_public_path__ + "assets/img/307cc06245ea71b50bdc963f74a64b40.svg";